import {Component, EventEmitter, inject, Output} from '@angular/core';
import {Observable, of} from "rxjs";
import {MatAutocompleteSelectedEvent} from "@angular/material/autocomplete";
import {FormControl} from "@angular/forms";
import {CitizensServices} from "../../../../store/entities/citizens/citizens-services/citizens-services.model";
import {Router} from "@angular/router";
import {CITIZEN_GET_SEARCHED_SERVICES, UPDATE_SEARCHED_SERVICE} from "../portal-home";
import {Apollo} from "apollo-angular";

@Component({
  selector: 'app-portal-service-search',
  templateUrl: './portal-service-search.component.html',
  styleUrl: './portal-service-search.component.scss'
})
export class PortalServiceSearchComponent {
  searchedKeyword = new FormControl('');
  filteredSearch: Observable<CitizensServices[]>;
  router = inject(Router);
  apollo = inject(Apollo);


  @Output() exitHover = new EventEmitter();

  onSearchChange() {
    if (this.searchedKeyword.value !== '')
      this.getCitizenSearchedServices(this.searchedKeyword.value);
    else this.filteredSearch = of([]);
  }

  onItemSelected(service:CitizensServices) {
    this.searchedKeyword.setValue(service?.serviceName);
    this.updateSearchedService(service?.serviceUniqueId);
    this.router.navigate([`/service-view/${service?.serviceUniqueId}`]);
  }

  updateSearchedService(serviceUniqueId) {
    this.apollo
      .mutate({
        mutation: UPDATE_SEARCHED_SERVICE,
        fetchPolicy: 'network-only',
        variables: {
          serviceUniqueId: serviceUniqueId,
        },
      })
      .toPromise()
      .then((data) => {
        let result: any = Object.values(data)[0];
        result = result.citizenUpdateSearchedServiceMutation;
        if (result?.response.code == '9000') {
        }
      });
  }


  getCitizenSearchedServices(keyword) {
    this.apollo
      .query({
        query: CITIZEN_GET_SEARCHED_SERVICES,
        fetchPolicy: 'network-only',
        variables: {
          searchKey: keyword,
        },
      })
      .toPromise()
      .then((data) => {
        let result: any = Object.values(data)[0];
        result = result.citizenGetSearchedServices;
        if (result?.response.code == '9000') {
          this.filteredSearch = of(result.data);
        }
      });
  }
}
